var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.776,
    height: 16.592,
    viewBox: "0 0 16.776 16.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_4_1",
    "data-name": "Component 4 \\u2013 1",
    transform: "translate(0.5 0.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13125",
    "data-name": "Group 13125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11239",
    "data-name": "Path 11239",
    d: "M99.7,9.435V12.4a1.841,1.841,0,0,1-1.84,1.84h-12.1a1.841,1.841,0,0,1-1.84-1.84V9.435",
    transform: "translate(-83.926 1.144)",
    fill: "none",
    stroke: "#566370",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11240",
    "data-name": "Path 11240",
    d: "M95.856,6.094l-4.77-4.77-4.77,4.77",
    transform: "translate(-83.199 -1.324)",
    fill: "none",
    stroke: "#566370",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_705",
    "data-name": "Line 705",
    y1: 11.269,
    transform: "translate(7.889)",
    fill: "none",
    stroke: "#566370",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandTwitter);
export default __webpack_public_path__ + "static/media/expandTwitter.030a77e6051cd0283097364b58382d13.svg";
export { ForwardRef as ReactComponent };